/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import ExclusiveWebinar from "./ExclusiveWebinar";

export default ExclusiveWebinar;
